import { routes as bloco } from './bloco';
import { routes as graute } from './graute';
import { routes as argamassa } from './argamassa';
import { EPermissoes } from '@/enums/ePermissoes';
// import { routes as nconaoconformidadetipo } from './nconaoconformidadetipo';

export default [
  {
    path: '/alvenaria',
    name: 'alvenariadefault',
    description: 'Alvenaria Estrutural',
    icon: 'uil-wall',
    children: [
      {
        path: 'dashboard',
        name: 'alvenaria',
        description: 'Dashboard',
        component: () => import('@/views/utilidade/Index.vue'),
        meta: {
          utlTipoFornecimentoId: [3, 4, 301],
          opcoesTipoFornecimento: { 3: 'Argamassa', 4: 'Graute', 301: 'Bloco' },
          permissions: [EPermissoes.Relatorio]
        },
        goesToMenu: true
      },
      {
        path: 'relatorios',
        name: 'alvenariarelatorios',
        description: 'Relatórios',
        component: () => import('@/views/utilidade/Relatorios.vue'),
        meta: {
          utlTipoFornecimentoId: [3, 4, 301],
          opcoesTipoFornecimento: { 3: 'Argamassa', 4: 'Graute', 301: 'Bloco' },
          permissions: [EPermissoes.Relatorio]
        },
        goesToMenu: true
      },
      ...bloco,
      ...graute,
      ...argamassa
    ],
    customChildren: ['Bloco', 'Graute', 'Argamassa']
  }
];
